import './style.scss';

import React, { useMemo } from 'react';

import { ENetwork, web3Configs } from 'web3';

interface INetworkIconProps {
  network: ENetwork;
}

const NetworkIcon: React.FC<INetworkIconProps> = ({ network }) => {
  const config = useMemo(() => web3Configs[network], [network]);

  return <img className="mm-trading-pair-network-icon" alt={config.label} src={config.logo} />;
};

export default NetworkIcon;
